import { THEMES } from './index.js';
import varsEcaterix from './../themes/ecaterix/assets/styles/vars'; // WEAK CODE: not reliable path, may change if directory does
import varsNovaporta from './../themes/novaporta/assets/styles/vars'; // WEAK CODE: not reliable path, may change if directory does
import varsFarmacie from './../themes/farmacie/assets/styles/vars';

export const getStylesResourcesPaths = theme => {
    const defaultAssets = ['@/assets/scss/style.scss'];
    const novaportaAssets = ['@/assets/scss/_reset.scss', '@/themes/novaporta/assets/styles/global.scss'];
    const ecaterixAssets = ['@/assets/scss/_reset.scss', '@/themes/ecaterix/assets/styles/global.scss'];
    const foundationAssets = ['@/themes/foundation/assets/scss/style.scss'];
    const primebuyAssets = ['@/themes/primebuy/assets/scss/style.scss'];
    const farmacieAssets = [
        '@/themes/farmacie/assets/styles/scss/_reset.scss',
        '@/themes/farmacie/assets/styles/scss/style.scss',
        '@/themes/farmacie/assets/styles/global.scss',
    ];
    const terenuriAssets = ['@/assets/scss/_reset.scss', '@/themes/terenuri/assets/scss/style.scss'];

    if (THEMES.novaporta === theme) return novaportaAssets;
    if (THEMES.ecaterix === theme) return ecaterixAssets;
    if (THEMES.foundation === theme) return foundationAssets;
    if (THEMES.farmacie === theme) return farmacieAssets;
    if (THEMES.primebuy === theme) return primebuyAssets;
    if (THEMES.terenuri === theme) return terenuriAssets;
    else return defaultAssets;
};

export const getStylesVarsPath = theme => {
    const novaportaPath = '~/themes/novaporta/assets/styles/vars';
    const ecaterixPath = '~/themes/ecaterix/assets/styles/vars';
    const farmaciePath = '~/themes/farmacie/assets/styles/vars';

    if (THEMES.novaporta === theme) return novaportaPath;
    else if (THEMES.ecaterix === theme) return ecaterixPath;
    else if (THEMES.farmacie === theme) return farmaciePath;
};

export const getVars = theme => {
    if (THEMES.novaporta === theme) return varsNovaporta;
    else if (THEMES.ecaterix === theme) return varsEcaterix;
    else if (THEMES.farmacie === theme) return varsFarmacie;
};
